exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-footer[data-v-2e7ae83f]{text-align:right}", ""]);

// exports
